module.exports = {"654224100":"托里镇","654224101":"铁厂沟镇","654224102":"庙尔沟镇","654224200":"多拉特乡","654224201":"乌雪特乡","654224202":"库普乡","654224203":"阿克别里斗乡","654224401":"白杨河林场","654224402":"老风口林场","654224403":"巴尔鲁克山塔斯特林场","654224510":"兵团农九师一七零团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654224.json
// module id = 3140
// module chunks = 0